@if (hasPermissions === false) {
  <div class="error" style="text-align: left;padding:10px 20px 0;">
    You do not have permissions to apply corrections to one or more of these series.
  </div>
}
@if (form) {
  <form class="form-dialog series-adjustment-tile" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-content-wrapper">
      <table style="text-align: left;" formArrayName="adjustments">
        @for (adjustment of adjustments.controls; track adjustment; let i = $index) {
          <ng-container [formGroupName]="i">
            <tr>
              <th style="width:30%;">Target series</th>
              <th style="width:30%;">Series to adjust</th>
              @if (adjustment.get('adjustment_type').value==='constant') {
                <th class="adjustment-input merged" colspan="2">
                  Value
                </th>
              }
              @if (adjustment.get('adjustment_type').value==='find_factor') {
                <th style="width:15%">Current Value</th>
              }
              @if (adjustment.get('adjustment_type').value==='find_factor') {
                <th style="width:25%;" class="adjustment-input">Target Value</th>
              }
              <th style="width: 50px;"></th><!--Comment-->
            </tr>
            <tr>
              <td>{{seriesDict[adjustment.get('target_series_id').value]?.attributes | nameOrDescription}}</td>
              <td>{{seriesDict[adjustment.get('series_id').value]?.attributes | nameOrDescription}}</td>
              @if (adjustment.get('adjustment_type').value==='constant') {
                <td colspan="2">
                <input formControlName="value" matInput type="number"/></td>
              }
              @if (adjustment.get('adjustment_type').value === 'find_factor') {
                <td>
                  {{seriesValues[adjustment.get('target_series_id').value] | formatNumber:seriesDict[adjustment.get('target_series_id').value]?.attributes?.decimal_places:true}}
                </td>
              }
              @if (adjustment.get('adjustment_type').value === 'find_factor') {
                <td>
                <input formControlName="target_value" matInput type="number" [ngClass]="{'input-error': adjustment.get('target_value').invalid && adjustment.get('target_value').touched}"/></td>
              }
              <td style="text-align: center;">
                <button type="button" class="icon-comment" [ngClass]="{'has-comment' : adjustment.value.comment}"
                (click)="$event.stopPropagation();openModal($event, adjustment);"></button>
              </td>
            </tr>
          </ng-container>
        }
      </table>
    </div>
    <div style="border-top: 1px solid #ccc; margin: 10px 0; width: 100%;"></div>
    <div class="bottom-button-container">
      <mat-checkbox formControlName="updateCalculations">Update all relevant calculations</mat-checkbox>
      <button type="submit" [disabled]="!form.valid || !isFormChanged()" class="bordered-button big-btn save" mat-button
        matTooltip="Submit adjustments" [matTooltip]="submitTooltip()">Submit
      </button>
    </div>
  </form>
}
